import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

const FarmContext = createContext(null);
export const useFarm = () => useContext(FarmContext);

export function FarmProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [theme, setThemeState] = useState(() => localStorage.getItem("agri-theme") || "light");
  const [version, setVersion] = useState(0);
  const [alertCount, setAlertCount] = useState(0);

  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem("agri-theme", theme);
  }, [theme]);

  const load = useCallback(async () => {
    const s = await api.getSettings();
    setSettings(s);
  }, []);

  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const s = await api.getSettings();
        setSettings(s);
        const rec = await api.monthlyRecords();
        setAlertCount((rec.alerts || []).filter((a) => a.concerning).length);
      } catch (e) {
        setErr("FETCH FAILED: " + (e?.message || String(e)));
      }
    })();
  }, []);

  const updateSettings = async (patch) => {
    const s = await api.updateSettings(patch);
    setSettings(s);
  };

  const refresh = () => setVersion((v) => v + 1);
  const toggleTheme = () => setThemeState((t) => (t === "dark" ? "light" : "dark"));

  const refreshAlerts = useCallback(async () => {
    try {
      const rec = await api.monthlyRecords();
      setAlertCount((rec.alerts || []).filter((a) => a.concerning).length);
    } catch (e) { /* ignore */ }
  }, []);

  const fmt = (n) =>
    `${settings?.currency_symbol || "$"}${Number(n || 0).toLocaleString(undefined, {
      maximumFractionDigits: 2,
    })}`;

  return (
    <FarmContext.Provider
      value={{
        settings,
        setActiveLivestock: (id) => updateSettings({ active_livestock: id }),
        updateSettings,
        theme,
        toggleTheme,
        fmt,
        version,
        refresh,
        alertCount,
        refreshAlerts,
        reload: load,
        err,
        ready: !!settings,
      }}
    >
      {children}
    </FarmContext.Provider>
  );
}
